import { render, staticRenderFns } from "./AmountChangeTab.vue?vue&type=template&id=4b812578&"
import script from "./AmountChangeTab.vue?vue&type=script&lang=ts&"
export * from "./AmountChangeTab.vue?vue&type=script&lang=ts&"
import style0 from "./AmountChangeTab.vue?vue&type=style&index=0&id=4b812578&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports